<template>
  <div class="product-card-skeleton flex flex-col overflow-hidden mr-5">
    <div class="image-skeleton w-full mb-4"></div>
    <div class="p-4">
      <div class="badge-skeleton w-3/4 mb-5 rounded-lg"></div>
      <div class="text-skeleton w-full mb-4 h-10"></div>
      <div class="border-b mt-8 mb-4"></div>
      <div class="text-skeleton w-1/2 h-5"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSkeleton"
}
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

.product-card-skeleton {
  width: 260px;
  height: 425px;
  background-color: #f6f7f8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  animation: shimmer 1.5s infinite linear;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #eaeaea 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 200% 100%;
}

.image-skeleton {
  height: 252px;
  background-color: #e0e0e0;
}

.badge-skeleton {
  height: 20px;
  background-color: #e0e0e0;
}

.text-skeleton {
  background-color: #e0e0e0;
  border-radius: 8px;
}
</style>
